/**
 * Shared API client with cookie-based auth.
 * 
 * BACKEND_URL is forced to empty string so all API paths are RELATIVE.
 * Auth is handled via httpOnly cookies — no tokens in localStorage.
 */
import axios from "axios";

const BACKEND_URL = "";
const API = `${BACKEND_URL}/api`;

/**
 * Global default: send cookies with every request.
 * The backend sets httpOnly session_token cookies on login/register/session.
 */
axios.defaults.withCredentials = true;

/** Dedicated API client (optional, for new code) */
const apiClient = axios.create({ baseURL: API, withCredentials: true });

export { API, BACKEND_URL, apiClient };
